import PropTypes from 'prop-types';
import Avatar from '../Avatar';
import clsx from 'clsx';
import classes from './DialogLine.module.scss';
import { useGameSounds } from "@educaplay/core/hooks";
import { NAME_SOUND_ACTIVE } from "@educaplay/core/utils";
import DialogLineWithoutAudioPlayer from './DialogLineWithoutAudioPlayer';
import DialogLineAudioPlayer from './DialogLineAudioPlayer';
import { forwardRef, useState } from 'react';

const DialogLine = forwardRef(function DialogLine(props, ref) {
   const { selected, reverse, className, onClick, media, onEnded, author, text, paused } = props;

   const [isHovered, setIsHovered] = useState(false);
   const gameSounds = useGameSounds();
   const Player = media ? DialogLineAudioPlayer : DialogLineWithoutAudioPlayer;

    return (
        <>
            <div 
                ref={ref} 
                className={clsx(classes.item, selected && classes.selected, reverse && classes.reverse, isHovered && classes.hovered, className)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <Avatar
                    selected={selected}
                    hovered={isHovered}
                    src={author.avatar}
                    onClick={onClick}
                />
                <button
                    type='button'
                    onClick={onClick}
                    className={classes.speechBubble}
                    onMouseEnter={() => gameSounds.play(NAME_SOUND_ACTIVE)}
                >
                    <div className={classes.name}>{author.name}</div>
                    <div className={classes.speech}>
                    {text}
                    </div>
                </button>
            </div>
            <Player
                paused={paused}
                selected={selected}
                mediaSrc={media?.src}
                onEnded={onEnded}
            />
        </>
    )
});

export default DialogLine;

DialogLine.propTypes = {
    selected: PropTypes.bool,
    reverse: PropTypes.bool,
    author: PropTypes.shape({
        name: PropTypes.string.isRequired,
        avatar: PropTypes.string
    }).isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    media: PropTypes.shape({
        type: PropTypes.oneOf(['audio']),
        src: PropTypes.string
    }),
    onEnded: PropTypes.func.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    paused: PropTypes.bool
}